// eslint-disable-next-line import/prefer-default-export
export function downloadTextFile(filename: string, content: string): void {
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });

  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const FileSaver = require('file-saver');
  FileSaver.saveAs(blob, filename);
}
